import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
export const dispatch_OnWorkHubTabsUpdated = new ThunderDispatcher('__onWorkHubTabsUpdated');
export const dispatch_OnWorkHubTabSelected = new ThunderDispatcher('__onWorkHubTabSelected');
export const dispatch_OnWorkHubTabClosed = new ThunderDispatcher('__onWorkHubTabClosed');
//# sourceMappingURL=dispatchers.js.map